import AdBackground from "../AdBackground/index.tsx";
import GalleryScrollButton from "../../Pages/Gallery/GalleryScrollButton.js";
import useBackground from "hooks/useBackground.ts";
import useMailSender from "hooks/useMailSender.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";

import { UploadComplete } from "../../Pages/Gallery/GalleryContent/UploadComplete/UploadComplete.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useMemo, useCallback, useRef, useState, useEffect } from "react";
import { useMobileAppHeight } from "hooks/useMobileAppHeight.js";
import { useMail } from "contexts/mailContext/mailContext.js";

import "./BackgroundCover.scss";
import { useUser } from "contexts/userContext/userContext.js";
import ThanksActionButton from "../ThanksActionButton/index.tsx";

const FOOTER_HEIGHT = 90;
const DEFAULT_HEIGHT = `calc(100vh - ${FOOTER_HEIGHT}px)`;
const IS_PREVIEW = window.location.pathname.includes("preview-ad-");

// ratio of FUll HD screen
const RATIO = 1920 / 1080;
const MOBILE_RATIO = 1080 / 1920;

const BackgroundCover = ({ children, contentRef }) => {
  //call to action button logic and structure
  const { getBackgroundCover, getMailStatus, getIsCollection } = useMail();
  const { getUserData, isSubscribed } = useUser();

  const {
    getTextByKey,
    getDefaultBackgroundImage,
    fetchDefaultBackgroundImage,
    getBlackFridayTime,
    getBlackFridayTimeCookie,
    getAdsBackground,
    setAdsBackground,
    getRandBackgroundRedirectUrl,
    getDirection,
  } = useContent();
  const { mobileCondition } = useMediaQueries();
  const { updateAdClickCount, getCampaignIdsForExcluding } = useBackground();
  const [isLoaded, setIsLoaded] = useState(false);

  const ratio = mobileCondition ? MOBILE_RATIO : RATIO;
  const height = !getAdsBackground()?.adId
    ? DEFAULT_HEIGHT
    : window.innerWidth / ratio;

  const { isMailSender, isMailSenderSubscribed } = useMailSender();

  const [backgroundSrc, setBackgroundSrc] = useState(
    getDefaultBackgroundImage()
  );

  const [backgroundOld, setBackgroundOld] = useState(false);

  const videoRef = useRef(null);

  useEffect(() => {
    const videoEl = document.getElementById("video-ad");

    if (videoEl) {
      videoEl.muted = true;

      videoEl.onloadeddata = () => {
        videoEl?.play?.();
      };
    }
  }, []);

  useEffect(() => {
    if (getUserData()?.UserBackgroundCoverImage) {
      setAdsBackground({});
    }
  }, [getUserData()?.UserId]);

  // getting default background image
  // (when more pages will need this (homepage, etc.), move this to higher level component)
  useMemo(() => {
    if (getDefaultBackgroundImage()) {
      if (!backgroundSrc) setBackgroundSrc(getDefaultBackgroundImage());
    } else
      fetchDefaultBackgroundImage({
        location: "DOWNLOAD",
        campaignIds: getCampaignIdsForExcluding(),
      });
  }, [getDefaultBackgroundImage(), backgroundSrc]);

  //support for old photos. check height before adding to state.
  const img = useRef();

  useMemo(() => {
    img.current = new Image();
    if (!img.current.src) {
      img.current.src = backgroundSrc;
    }
  }, []);

  // after loading the image, check if smaller than 300px and set as background
  img.current.onload = useCallback(() => {
    if (img.current) {
      setBackgroundOld(img.current.height < 300);
    }
  }, [img.current.src]);

  useMemo(() => {
    getBackgroundCover() &&
    (isMailSenderSubscribed || isMailSender()) &&
    !IS_PREVIEW
      ? setBackgroundSrc(getBackgroundCover())
      : setBackgroundSrc(getDefaultBackgroundImage());
  }, [getBackgroundCover()]);

  useMobileAppHeight();
  const conditionNoAds =
    !getAdsBackground().adId || getAdsBackground().isBlocked;

  const handleBannerClick = async (e) => {
    if (checkCurrDomainIsOrgDomain()) {
      return;
    }
    const className = e.target.className;

    if (
      className.includes("background-branding-cover") ||
      className.includes("video-ad-bg")
    ) {
      if (
        getAdsBackground().adId &&
        getAdsBackground().isBlocked &&
        getAdsBackground()?.redirectUrl &&
        !IS_PREVIEW
      ) {
        await updateAdClickCount();
      }
    }
  };

  const preventAdRedirectWhenCLickNotOnBg = (e) => {
    // Get target class name
    if (
      !e.target.className.includes("background-branding-cover") &&
      !e.target.className.includes("video-ad-bg")
    ) {
      e.preventDefault();
    }
  };

  // const imgLinkCoords = mobileCondition
  //   ? getAdsBackground().mobileCoordinates
  //   : getAdsBackground()?.desktopCoordinates;

  return (
    <>
      <a
        href={
          checkCurrDomainIsOrgDomain()
            ? undefined
            : getAdsBackground().redirectUrl ||
              getRandBackgroundRedirectUrl() ||
              undefined
        }
        target="_blank"
        rel="noreferrer"
        onClick={preventAdRedirectWhenCLickNotOnBg}
        className="gallery-ads-container"
        style={{
          height: getAdsBackground().adId ? height : DEFAULT_HEIGHT,
          maxHeight: DEFAULT_HEIGHT,
        }}
      >
        {!getIsCollection() && <UploadComplete />}
        <div
          className={`background-branding-cover ${backgroundOld ? "old" : ""} ${
            getBlackFridayTime() && getBlackFridayTimeCookie()
              ? "black-friday"
              : ""
          }`}
          id="home-bgd-image"
          onClick={handleBannerClick}
          style={
            (getMailStatus() && conditionNoAds) || IS_PREVIEW
              ? {
                  backgroundImage:
                    getAdsBackground()?.fileType !== "Video"
                      ? `url('${backgroundSrc}')`
                      : "none",
                  height,
                  position: "relative",
                }
              : {
                  height: DEFAULT_HEIGHT,
                }
          }
        >
          {/* {imgLinkCoords ? (
            <img
              className="img-replacer-for-coords"
              src={backgroundSrc}
              onLoad={() => setIsLoaded(true)}
              useMap="#imgMap"
              alt="coords replacer"
            />
          ) : null}
          {isLoaded ? (
            <map name="imgMap" style={{ pointerEvents: "all" }}>
              <area
                shape="rect"
                coords={imgLinkCoords}
                href={
                  getAdsBackground().redirectUrl ||
                  getRandBackgroundRedirectUrl()
                }
                target="_blank"
                rel="noreferrer"
                alt={getAdsBackground()?.description}
              />
            </map>
          ) : null} */}
          {getAdsBackground()?.fileType === "Video" ? (
            <video
              className="video-ad-bg"
              autoPlay
              muted
              loop
              ref={videoRef}
              id="video-ad"
              onClick={handleBannerClick}
            >
              <source src={backgroundSrc} type="video/mp4" />
            </video>
          ) : null}
          <AdBackground />
          <GalleryScrollButton
            contentRef={contentRef}
            style={{
              // top: bgHeight ? bgHeight / 2 - 190 : "calc(100vh / 2 - 190px)",
              top: "calc(100vh / 2 - 190px)",
            }}
          >
            {getTextByKey("scroll-to-bottom")}
          </GalleryScrollButton>
          {!isMailSenderSubscribed &&
            !isSubscribed() &&
            !getUserData().IsSubUser && <ThanksActionButton />}
        </div>
      </a>
      {backgroundOld ? (
        <div
          className="background-branding-cover blur"
          style={
            getMailStatus()
              ? {
                  backgroundImage: `url('${backgroundSrc}')`,
                }
              : null
          }
        ></div>
      ) : null}
    </>
  );
};

export default BackgroundCover;
